import * as React from 'react';

import { AnswerItem } from '../../components/AnswerItem';
import { AuthorContainer } from './Author';
import { CommentContainer } from './Comment';
import { FooterContainer } from './Footer';
import { AvatarContainer } from './Avatar';

interface IAnswerContainerProps {
  id: string;
  inPopup?: boolean;
}

export function AnswerItemContainer({ id, inPopup }: IAnswerContainerProps) {
  return (
    <AnswerItem
      inPopup={inPopup}
      aside={<AvatarContainer answerId={id} />}
      author={<AuthorContainer answerId={id} />}
      comment={<CommentContainer answerId={id} />}
      footer={<FooterContainer answerId={id} />}
    />
  );
}
